import { FC, ReactNode } from 'react';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { UILoader } from '../ui-loader';

import FileXMarkIcon from '@/app/assets/icons/file-xmark.svg?react';

export interface EmptyDataPlaceholderProps {
  isEmpty: boolean;
  title: string;
  subtitle?: ReactNode;
  endAdornment?: ReactNode;
  children?: ReactNode;
  isLoading?: boolean;
  icon?: ReactNode;
  sx?: SxProps;
}
export const EmptyDataPlaceholder: FC<EmptyDataPlaceholderProps> = ({
  isEmpty,
  title,
  subtitle,
  endAdornment,
  children,
  isLoading,
  icon,
  sx,
}) => {
  if (isLoading) {
    return <UILoader />;
  }
  if (isEmpty) {
    return (
      <Stack spacing={4} alignItems='center' justifyContent='center' m='auto' py={2} sx={sx}>
        <Stack
          alignItems='center'
          justifyContent='center'
          className='empty-data-placeholder-icon'
          sx={{
            bgcolor: 'rgba(21, 85, 252, 0.04)',
            borderRadius: '50%',
            width: 80,
            height: 80,
          }}
        >
          {icon || <Box component={FileXMarkIcon} />}
        </Stack>

        <Stack alignItems='center'>
          {title && <Typography variant='h3'>{title}</Typography>}

          {subtitle && (
            <Typography mt={1} variant='subtitle2'>
              {subtitle}
            </Typography>
          )}
        </Stack>

        {endAdornment}
      </Stack>
    );
  }
  return children;
};
